var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 30.8333C43.8115 30.8333 49.3333 25.3115 49.3333 18.5C49.3333 11.6884 43.8115 6.16663 37 6.16663C30.1884 6.16663 24.6666 11.6884 24.6666 18.5C24.6666 25.3115 30.1884 30.8333 37 30.8333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6639 66.2528C43.2441 67.8333 45.7878 67.8333 50.875 67.8333C55.9622 67.8333 58.506 67.8333 60.0862 66.2528C61.6667 64.6726 61.6667 62.1289 61.6667 57.0417C61.6667 51.9545 61.6667 49.4107 60.0862 47.8305C58.506 46.25 55.9622 46.25 50.875 46.25C45.7878 46.25 43.2441 46.25 41.6639 47.8305C40.0834 49.4107 40.0834 51.9545 40.0834 57.0417C40.0834 62.1289 40.0834 64.6726 41.6639 66.2528ZM49.0765 55.2432H46.0786C45.0855 55.2432 44.2801 56.0482 44.2801 57.0417C44.2801 58.0351 45.0855 58.8402 46.0786 58.8402H49.0765H52.6735H55.6715C56.6646 58.8402 57.47 58.0351 57.47 57.0417C57.47 56.0482 56.6646 55.2432 55.6715 55.2432H52.6735H49.0765Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.7919 46.3462C54.4821 46.25 52.8751 46.25 50.875 46.25C45.7878 46.25 43.244 46.25 41.6638 47.8306C40.0833 49.4108 40.0833 51.9545 40.0833 57.0417C40.0833 60.6378 40.0833 62.9629 40.6417 64.5752C39.4577 64.6902 38.241 64.75 37 64.75C25.0798 64.75 15.4166 59.2281 15.4166 52.4167C15.4166 45.6053 25.0798 40.0834 37 40.0834C45.0579 40.0834 52.0849 42.6068 55.7919 46.3462Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveUser);
export default __webpack_public_path__ + "static/media/RemoveUser.0073d41937abf265f7184ff7f829b448.svg";
export { ForwardRef as ReactComponent };